var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "uni-real-test allTest" }, [
    _c(
      "div",
      { staticClass: "real-test-filter" },
      [
        _c("Title", { attrs: { text: "练习中心" } }),
        _c(
          "div",
          { staticClass: "titleTab" },
          [
            _c(
              "el-tabs",
              {
                on: { "tab-click": _vm.setTypeId },
                model: {
                  value: _vm.type_id,
                  callback: function ($$v) {
                    _vm.type_id = $$v
                  },
                  expression: "type_id",
                },
              },
              _vm._l(_vm.TestTypeList, function (item, index) {
                return _c("el-tab-pane", {
                  key: index,
                  attrs: { label: item.title, name: item.id + "" },
                })
              }),
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "box filter-box" }, [
          _c("ul", { staticClass: "filter-list" }, [
            _c("li", { staticClass: "item" }, [
              _c("span", { staticClass: "tit" }, [_vm._v("课程选择")]),
              _c(
                "div",
                { staticClass: "con", staticStyle: { "margin-top": "-5px" } },
                _vm._l(_vm.selectList, function (item) {
                  return _c(
                    "el-button",
                    {
                      key: item.id,
                      staticClass: "course mab20",
                      class: item.id === _vm.course_id ? "active" : "",
                      attrs: { size: "mini", round: "" },
                      on: {
                        click: function ($event) {
                          return _vm.courseSelect(item.id)
                        },
                      },
                    },
                    [_vm._v(_vm._s(item.title) + " ")]
                  )
                }),
                1
              ),
            ]),
          ]),
        ]),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "real-test-box", attrs: { id: "real-test-box" } },
      [
        _vm.type_name !== "章节练习" && _vm.type_name !== "智能练习"
          ? _c(
              "div",
              [
                _c(
                  "ul",
                  { staticClass: "real-test-list" },
                  _vm._l(_vm.paperLists.list, function (item) {
                    return _c(
                      "li",
                      { key: item.id, staticClass: "item" },
                      [
                        _c("div", { staticClass: "img-box" }),
                        _c("div", { staticClass: "content" }, [
                          _c("p", { staticClass: "tit" }, [
                            _vm._v(" " + _vm._s(item.title) + " "),
                          ]),
                          _c("p", { staticClass: "info" }, [
                            _c("span", [
                              _c("i", { staticClass: "iconfont iconjilu" }),
                              _vm._v(
                                "考试时长：" + _vm._s(item.duration) + "分钟"
                              ),
                            ]),
                            _c("span", [
                              _c("i", { staticClass: "iconfont iconkecheng" }),
                              _vm._v(
                                "共计：" + _vm._s(item.questionNum) + "道题"
                              ),
                            ]),
                            _c("span", [
                              _c("i", {
                                staticClass: "iconfont iconfenshijuan",
                              }),
                              _vm._v(
                                "总分：" + _vm._s(item.total_score) + "分"
                              ),
                            ]),
                          ]),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "mar50",
                            staticStyle: { width: "200px" },
                          },
                          [
                            item.is_test === 1
                              ? _c("span", { staticClass: "green" }, [
                                  _vm._v("已做过"),
                                ])
                              : _vm._e(),
                            item.is_test === 0
                              ? _c("span", { staticClass: "primary" }, [
                                  _vm._v("未做过"),
                                ])
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "test-btn",
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.jump(item.id)
                              },
                            },
                          },
                          [_vm._v("开始练习测试")]
                        ),
                      ],
                      1
                    )
                  }),
                  0
                ),
                _vm.paperLists.total === 0
                  ? _c("ComponentEmpty", {
                      attrs: { title: "暂无考试试卷", tips: "" },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm.type_name == "章节练习"
          ? _c(
              "div",
              [_c("Practice", { attrs: { courseUuid: _vm.course_id } })],
              1
            )
          : _vm._e(),
        _vm.type_name == "智能练习"
          ? _c("div", { staticClass: "smart" }, [
              _c(
                "div",
                { staticClass: "smartTab" },
                _vm._l(_vm.smartBnt, function (item, index) {
                  return _c(
                    "el-button",
                    {
                      key: index,
                      class:
                        _vm.setSmartActive == item.smartActive
                          ? "test-btn"
                          : "tab-btn",
                      on: {
                        click: function ($event) {
                          return _vm.setSmartType(item.smartActive)
                        },
                      },
                    },
                    [_vm._v(_vm._s(item.bntText))]
                  )
                }),
                1
              ),
              _vm.setSmartActive === "orderly"
                ? _c(
                    "div",
                    { staticClass: "real-test-list" },
                    [
                      _c(
                        "el-collapse",
                        { attrs: { accordion: "" } },
                        _vm._l(_vm.smartDataList, function (item, index) {
                          return _c(
                            "el-collapse-item",
                            { key: index },
                            [
                              _c("template", { slot: "title" }, [
                                _c("li", { staticClass: "item" }, [
                                  _c("div", { staticClass: "img-box1" }, [
                                    _c("p"),
                                    _c("span", [
                                      _vm._v(_vm._s(item.title.slice(0, 1))),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "content" }, [
                                    _c("p", { staticClass: "tit" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(item.title.slice(0, -2)) +
                                          " "
                                      ),
                                    ]),
                                    _c("p", { staticClass: "info" }, [
                                      _c("span", [
                                        _vm._v(
                                          "共" + _vm._s(item.total) + "题"
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ]),
                              ]),
                              _vm._l(item.list, function (itemTo, indexTo) {
                                return _c(
                                  "div",
                                  { key: indexTo, staticClass: "itemDiv" },
                                  [
                                    _c("p", [
                                      _vm._v(" " + _vm._s(itemTo.title) + " "),
                                    ]),
                                    _c(
                                      "div",
                                      [
                                        _c("p", [
                                          itemTo.make_status == 0
                                            ? _c("span", [_vm._v("未练习")])
                                            : _vm._e(),
                                          itemTo.make_status == 1
                                            ? _c("span", [_vm._v("练习中")])
                                            : _vm._e(),
                                          itemTo.make_status === 2
                                            ? _c("span", [_vm._v("已完成")])
                                            : _vm._e(),
                                        ]),
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "test-btn",
                                            attrs: { type: "primary" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.smartStart(
                                                  item,
                                                  itemTo.start,
                                                  itemTo.title
                                                )
                                              },
                                            },
                                          },
                                          [
                                            itemTo.make_status == 0
                                              ? _c("span", [_vm._v("开始练习")])
                                              : itemTo.make_status == 1
                                              ? _c("span", [_vm._v("继续练习")])
                                              : _c("span", [
                                                  _vm._v("再练一次"),
                                                ]),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "smartDisorderly" },
                    [
                      _vm._m(0),
                      _c(
                        "ul",
                        { staticClass: "smartDisorderlyUl" },
                        _vm._l(_vm.smartDataList, function (item, index) {
                          return _c(
                            "li",
                            { key: index },
                            [
                              _c(
                                "el-checkbox",
                                {
                                  attrs: { label: item.title },
                                  model: {
                                    value: _vm.checkedActive,
                                    callback: function ($$v) {
                                      _vm.checkedActive = $$v
                                    },
                                    expression: "checkedActive",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(item.title) +
                                      "(" +
                                      _vm._s(item.total) +
                                      ")"
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                      this.checkedActive.length > 0
                        ? _c(
                            "el-button",
                            {
                              staticClass: "test-btn",
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.randomStart()
                                },
                              },
                            },
                            [_vm._v("开始练习")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
            ])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "title" }, [
      _c("em"),
      _c("span", [_vm._v("请选择随机出题题型")]),
      _c("em"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }